import { type FC } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { authRoutes } from './authRoutes';
import { dashboardRoutes } from './dashboardRoutes';
import { errorRoutes } from './errorRoutes';

export const AppRoutes: FC = () => {
  return (
    <Routes>
      {/* Root redirect - redirect to file-upload for authenticated users */}
      <Route path="/" element={<Navigate to="/file-upload" replace />} />

      {/* Auth routes */}
      {authRoutes}

      {/* Error pages */}
      {errorRoutes}

      {/* Dashboard routes with protection */}
      {dashboardRoutes}

      {/* Catch all route - redirect to 404 */}
      <Route path="*" element={<Navigate to="/404" replace />} />
    </Routes>
  );
};
